/* eslint-disable */
"use client";

import * as React from "react";
import createIcon from "../Icon/createIcon";
export default createIcon( /*#__PURE__*/React.createElement(React.Fragment, null, /*#__PURE__*/React.createElement("path", {
  d: "M12 2a9.97 9.97 0 0 1 7.07 2.929.76.76 0 1 1-1.074 1.074A8.45 8.45 0 0 0 12 3.52 8.48 8.48 0 1 0 20.48 12 .76.76 0 0 1 22 12c0 5.523-4.477 10-10 10S2 17.523 2 12 6.477 2 12 2Z"
}), /*#__PURE__*/React.createElement("path", {
  d: "M12 5.696c1.694 0 3.283.672 4.457 1.846a.76.76 0 1 1-1.074 1.075A4.784 4.784 0 1 0 16.784 12a.76.76 0 1 1 1.52 0A6.304 6.304 0 1 1 12 5.696Z"
}), /*#__PURE__*/React.createElement("path", {
  d: "M12 9.392a2.608 2.608 0 1 0 0 5.216 2.608 2.608 0 0 0 0-5.216Zm0 1.52a1.088 1.088 0 1 1 0 2.176 1.088 1.088 0 0 1 0-2.176Z"
}), /*#__PURE__*/React.createElement("path", {
  d: "M19.237 3.835a.76.76 0 0 1 1.13 1.01l-.069.077-6.467 6.31a.76.76 0 0 1-1.13-1.01l.07-.077 6.466-6.31Z"
})), "0 0 24 24", "Radar");